import { render, staticRenderFns } from "./ProcategoriesList.vue?vue&type=template&id=75aa32f1&scoped=true&"
import script from "./ProcategoriesList.vue?vue&type=script&lang=js&"
export * from "./ProcategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./ProcategoriesList.vue?vue&type=style&index=0&id=75aa32f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa32f1",
  null
  
)

export default component.exports